/**
 * The shape of a top-level node in a hub page layout that the template lock
 * cares about. Kept structural so the signature can be unit tested without
 * building a ProseMirror document.
 */
export interface TopLevelNode {
	attrs?: { extensionKey?: string | null; localId?: string | null } | null;
	type: { name: string };
}

/**
 * A string identifying a hub page's *structure*: which elements are on it, and
 * in what order. Two documents with the same signature differ only in element
 * content, so a transaction that preserves the signature is a content edit.
 *
 * `localId` is what distinguishes two instances of the same extension;
 * `extensionKey` additionally catches a swap that reuses a localId. `parameters`
 * is deliberately excluded — that is exactly what admins are still allowed to
 * change on a locked page.
 */
export const getTopLevelSignature = (nodes: readonly TopLevelNode[]): string =>
	nodes
		.map((node) => {
			const { extensionKey, localId } = node.attrs ?? {};
			return `${node.type.name}/${extensionKey ?? ''}/${localId ?? ''}`;
		})
		.join('|');
